export const INITIALIZE_USER = 'INITIALIZE_USER';
export const LANGUAGE_CHANGE = 'LANGUAGE_CHANGE';
export const LOGOUT = 'LOGOUT';
export const SET_PHONE_LANGUAGE = 'SET_PHONE_LANGUAGE';

export interface UserState extends User {
  phoneLanguage: string;
}

interface InitializeUserAction {
  type: typeof INITIALIZE_USER;
  user: Partial<UserState>;
}

interface LanguageChangeAction {
  type: typeof LANGUAGE_CHANGE;
  language: string;
}

interface SetPhoneLanguageAction {
  type: typeof SET_PHONE_LANGUAGE;
  language: string;
}

interface UserLogoutAction {
  type: typeof LOGOUT;
}

export type UserActions =
  | InitializeUserAction
  | LanguageChangeAction
  | SetPhoneLanguageAction
  | UserLogoutAction;
